<template>
  <div>
    <template v-for="l in layers">
      <template v-if="checkCondition(l)">
        <image-field
          v-if="l.type === 'Image' &&
                l.personalized &&
                l.personalized.enable &&
                !l.imageLyric &&
                !l.imageMap &&
                !l.imageShape &&
                !l.imageStarMap &&
                !l.imageCutFace &&
                !l.imageRemoveBackground &&
                !l.imageScrabble &&
                !l.imageCalendarPicker &&
                !l.imageToy3d &&
                !l.imageqrcode &&
                !l.imageHandWriting &&
                !l.imageMoonPhase"
          :key="l.id"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
        />
        <text-field
          v-if="l.type === 'Text' && l.personalized && l.personalized.enable"
          :key="l.id"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
        />
        <label-field
          v-if="l.type === 'Label' "
          :key="l.id"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />
        <group-field
          v-if="l.type === 'Group'"
          :layer="l"
          :artwork="artwork"
          :key="l.id"
          :personalized="personalized"
          @ChangeGroupApplySky='ChangeApplySky'
          @ChangeTextMapChild='ChangeTextMapChild'
          @ChangeTextSongLyric="ChangeTextSongLyric"
          @changeTextMoonPhase="ChangeTextMoonPhase"
        />

        <lyrics-field
          v-if="l.type === 'Image' && l.imageLyric && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
          @ChangeTextSongLyric="ChangeTextSongLyric"
        />

        <map-field
          v-if="l.type === 'Image' && l.imageMap && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
          @ChangeTextMapChild='ChangeTextMapChild'
        />

        <image-shape-field
          v-if="l.type === 'Image' && l.imageShape && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <image-cut-face-field
          v-if="l.type === 'Image' && l.imageCutFace && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <image-remove-background-field
          v-if="l.type === 'Image' && l.imageRemoveBackground && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <ImageStarMapField
          v-if="l.type === 'Image' && l.imageStarMap && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
          @ChangeApplySky="ChangeApplySky"
        />

        <ImageScrabbleField
          v-if="l.type === 'Image' && l.imageScrabble && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

         <ImageCalendarPickerField
          v-if="l.type === 'Image' && l.imageCalendarPicker && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <ImageToy3dField
          v-if="l.type === 'Image' && l.imageToy3d && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <ImageQRField
          v-if="l.type === 'Image' && l.imageqrcode && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <ImageHandWritingField
          v-if="l.type === 'Image' && l.imageHandWriting && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
        />

        <ImageMoonPhaseField
          v-if="l.type === 'Image' && l.imageMoonPhase && l.personalized && l.personalized.enable"
          :layer="l"
          :artwork="artwork"
          :personalized="personalized"
          :name="l.id"
          @changeTextMoonPhase="ChangeTextMoonPhase"
        />
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ImageField from './ImageField.vue'
import TextField from './TextField.vue'
import LyricsField from './LyricsField.vue'
import MapField from './MapField.vue'
import ImageShapeField from './ImageShapeField.vue'
import ImageStarMapField from './ImageStarMapField.vue'
import ImageCutFaceField from './ImageCutFaceField'
import ImageRemoveBackgroundField from './ImageRemoveBackgroundField'
import LabelField from "./LabelField";
import { get, cloneDeep, orderBy } from 'lodash'
import { checkCondition } from '@/helper/helper'
import ImageScrabbleField from './ImageScrabbleField.vue'
import ImageHandWritingField from './ImageHandWritingField.vue'
import ImageCalendarPickerField from './ImageCalendarPickerField';
import ImageToy3dField from "./ImageToy3dField"
import ImageQRField from "./ImageQRField"
import ImageMoonPhaseField from './ImageMoonPhaseField.vue'
export default {
  name: 'group-field',
  components: {
    ImageCutFaceField,
    ImageField,
    TextField,
    LyricsField,
    MapField,
    ImageShapeField,
    ImageStarMapField,
    LabelField,
    ImageRemoveBackgroundField,
    ImageScrabbleField,
    ImageHandWritingField,
    ImageCalendarPickerField,
    ImageToy3dField,
    ImageQRField,
    ImageMoonPhaseField
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    //...mapGetters(['personalized']),
    layers() {
      var layers = cloneDeep(this.layer.layers || [])
      return orderBy(layers.reverse(), l => l.ordering || 0)
    }
    // artworkData() {
    //   const { personalized, artwork } = this
    //   return get(personalized, artwork.id, {})
    // }
  },
  methods: {
    checkCondition(layer) {
      const { personalized } = this
      return checkCondition(layer, personalized)
    },
    ChangeApplySky(data){
      this.$emit('ChangeGroupApplySky', data)
    },
    ChangeTextMapChild(data){
      this.$emit('ChangeTextMapChild', data)
    },
    ChangeTextSongLyric(v){
      this.$emit('ChangeTextSongLyric', v)
    },
    ChangeTextMoonPhase(data){
      this.$emit('changeTextMoonPhase', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/GroupField.vue